import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Activity } from "lucide-react";

export function RequireAuth({ children }) {
  const { user, authReady } = useAuth();
  const location = useLocation();

  if (!authReady) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-[#F4F7F9]"
        data-testid="auth-loading"
      >
        <div className="flex items-center gap-2 text-slate-400 text-sm">
          <Activity className="w-4 h-4 animate-pulse" />
          Loading…
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}

export default RequireAuth;
